import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "География. 10 класс",
        subject: "Взаимодействие человека и природы",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Взаимодействие человека и природы",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Дюкова Светлана Евгеньевна",
                grade: "научный сотрудник лаборатории социально-гуманитарного общего образования ФГБНУ «Институт стратегии развития образования»",
                subGrade: "",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: "<p style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>Выбор темы обусловлен её важностью для современного этапа развития общества, постоянным появлением новых для изучения в школе сюжетов, связанных с глобальными проблемами человечества, а также возможностью реализации целей устойчивого развития.  </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Тема важна для достижения личностных результатов обучения, особенно в области экологического воспитания и формирования ценностного отношения к проблемам взаимодействия человека и общества. Тема сквозной линией проходит через содержание учебного предмета «География». В 10 классе изучается она на более высоком уровне обобщения. Она важна как для систематизации ранее изученного материала, так и для дальнейшего изучения глобальных проблем человечества при завершении изучения предмета. </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>В ролике раскрываются методические пути освоения нового понятия – «климатические беженцы» в связи с планируемыми результатами обучения, подходы к организации и проведению практической работы «Определение целей и задач учебного исследования, связанного с опасными природными явлениями/глобальными изменениями климата/загрязнением Мирового океана, выбор формы фиксации результатов наблюдения/исследования».</p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Остановимся на работе с понятиями «климатические беженцы» и «миграции населения». Эти понятия целесообразно вводить, вспомнив об изменениях климата как глобальной проблемы.</p>"
                        },
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4",
            contentBefore: [{
                type: "text",
                text: `<p style="text-indent: 2vw;">С понятием «миграция» обучающиеся знакомы из курса «География России», его целесообразно актуализировать для дальнейшей работы. Например, учитель может предложить заполнить схему различных видов миграций (её форма может быть любой), провести фронтальную беседу, предложив одному ученику произносить прилагательное, обозначающее вид миграций, а другому пояснить, что это. Такую же работу можно организовать в мини-группах или парах.</p>
                        <p style="text-indent: 2vw;">Педагог может организовать образовательный процесс так, чтобы обучающиеся сами пришли к выводу о том, кто такие климатические беженцы или мигранты. Например, задать вопросы: «Предположите, кто такие «климатические мигранты»? Что заключено в этом названии? Откуда и куда они мигрируют?». Обучающиеся приходят к выводу, что в названии отражена причина миграций: климатические мигранты покидают места, где жить становится невозможно из-за изменения климата.</p>
                        <p style="text-indent: 2vw;">Работа с понятием «климатические беженцы», которое ещё не имеет чёткого статуса в международных документах, позволяет учителю провести школьников через небольшое исследование, показывающее практическое значение необходимости чёткого определение понятий.</p>
                        <p style="text-indent: 2vw;">Для организации работы используется статья «Великое переселение будущего: кто такие климатические мигранты», опубликованную на РБК (ссылка на эту статью имеется в материалах к кейсу). </p>
                        
                    `
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Волкова Т. «Мир ещё не сталкивался с исчезновением страны из-за климата» Министр тонущего государства — о жизни по колено в воде. URL. https://lenta.ru/articles/2021/11/30/simon_kofe/  (дата обращения 29.04.2023)",
                "Гашков И. Беженцы из тёплых стран: готов ли мир к большой климатической миграции? URL. https://tass.ru/mezhdunarodnaya-panorama/8736463 (дата обращения 15.03.2023)",
                "Грязневич. В. Балтика угрожает: как скажется глобальное потепление в Петербурге. URL. https://www.rbc.ru/spb_sz/08/01/2023/63ba81d79a7947e8ac40ace4 (дата обращения 29.04.2023)",
                "Дамбы не спасут прибрежные территории от наводнений. Какие города окажутся под водой из-за изменения климата. URL. https://www.mn.ru/smart/damby-ne-spasut-pribrezhnye-territorii-ot-navodnenij-kakie-goroda-okazhutsya-pod-vodoj-iz-za-izmeneniya-klimata (дата обращения 26.04.2023)",
                "Журенков К. Великая стена. URL. https://www.kommersant.ru/doc/4274758 (дата обращения 29.04.2023)",
                "Зворыкина Ю.В., Тетерятников К.С. Климатическая (или экологическая?) миграция: проблемы и перспективы // Научные труды Вольного экономического общества России. 2019. №2. URL. https://cyberleninka.ru/article/n/klimaticheskaya-ili-ekologicheskaya-migratsiya-problemy-i-perspektivy (дата обращения: 29.04.2023).",
                "Кадомцев А. Климатические беженцы: как природные катаклизмы повлияют на потоки миграции. URL.  https://interaffairs.ru/news/show/27460 (дата обращения 28.04.2023)",
                "Кориненко Е. Срываемся с места: Россия готовится к климатической миграции. Может ли глобальное потепление вынудить жителей сменить регион. URL. https://iz.ru/1239025/ekaterina-korinenko/sryvaemsia-s-mesta-rossiia-gotovitsia-k-klimaticheskoi-migratcii (дата обращения 15.04.2023)",
                "Кузнецова Ю.С.  Мы сами не местные. Кто такие климатические беженцы и откуда они бегут. URL. https://nplus1.ru/material/2020/02/18/climate-refugees (дата обращения 15.03.2023)",
                "Кузнецова Ю. С. «Проблема климатических мигрантов неизбежно коснётся и России» URL. https://geography.hse.ru/news/508621091.html (дата обращения 29.04.2023)",
                "Смертин В. Вице-премьер предрекла России наплыв климатических мигрантов: откуда ждать беженцев. URL. https://www.kp.ru/daily/27287.5/4424184/ (дата обращения 29.04.2023)",
                "Соболевская О.В. Картотека: климатические миграции: Откуда и куда переезжают люди из-за последствий изменений климата. URL. https://iq.hse.ru/news/645594361.html (дата обращения29.03.2023)",
                "Стрельников К. Вы ещё не знаете про климатических беженцев? Тогда они идут к вам. URL.https://ria.ru/20200126/1563870448.html (дата обращения 15.03.2023)",
                "Троянова А. Великое переселение будущего: кто такие климатические мигранты. URL. https://trends.rbc.ru/trends/green/60b0a6d59a794726b0de9e6d (дата обращения 15.04.2023)",
                "Троянова А. Бремя страстей климатических: как связаны потепление, войны и миграция. URL. https://trends.rbc.ru/trends/green/611ce43f9a79471322c2c112 (дата обращения 29.04.2023)",
                "Харитонов К. Убегая от катастрофы: климатические мигранты.  URL. https://ecosphere.press/2021/02/15/ubegaya-ot-katastrofy-klimaticheskie-migranty/ (дата обращения 13.04.2023)",
            ],
            sites: [
                ""
            ],
            filesToDownload: [
                {
                    link: "./files/tasks.pdf",
                    fileName: "Задания по теме"
                }
            ]
        }
    ],
};
